import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import classNames from "classnames";

import { getKPIsNrsData } from "modules/reporting/fordReports/kpis/store/kpis.actions";
import { makeActualScoreCardFilterData } from "modules/reporting/fordReports/utils";
import LoadingComponent from "modules/primitives/loading/loading.component";
import styles from './styles.module.scss';
import genericStyles from '../../styles.module.scss';

const FordProjectNumbers = ({ nrsData, filters }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (!nrsData.data) {
      const makeFilters = makeActualScoreCardFilterData(filters);
      const payload = {
        enqueueSnackbar,
        data: makeFilters,
      };

      dispatch(getKPIsNrsData(payload))
    }
  }, []);

  return (
    <div className={classNames('d-flex flex-column', styles.numbersWrapper)}>
      <div className={classNames(genericStyles.columnCard, 'align-items-center')}>
        {
          nrsData.fetching ? (
            <LoadingComponent customText="Getting Total Projects..." />
          ) : (
            <>
              <span className={styles.sectionName}>Total Projects</span>
              <span className={styles.medium}>{nrsData.data?.total_projects || "NA"}</span>
            </>
          )
        }
      </div>
      <div className="d-flex h-100">
        <div className={classNames(genericStyles.columnCard, "w-50 mr-1 align-items-center")}>
          {
            nrsData.fetching ? (
              <LoadingComponent customText="Getting AVG TARR (%)..." />
            ) : (
              <>
                <span className={styles.sectionName}>AVG TARR (%)</span>
                <span className={styles.big}>
                  {`${nrsData.data?.avg_tar?.main_value}${nrsData.data?.avg_tar?.main_value ? '%' : ''}` || "NA"}
                </span>
              </>
            )
          }
        </div>
        <div className={classNames(genericStyles.columnCard, "w-50 ml-1 align-items-center")}>
          {
            nrsData.fetching ? (
              <LoadingComponent customText="Getting Replications..." />
            ) : (
              <>
                <span className={styles.sectionName}>Replications</span>
                <span className={styles.big}>{nrsData.data?.total_replications || "NA"}</span>
              </>
            )
          }
        </div>
      </div>
      <div className="d-flex h-100">
        <div className={classNames(genericStyles.columnCard, "w-50 mr-1 align-items-center mb-0")}>
          {
            nrsData.fetching ? (
              <LoadingComponent customText="Getting Investment ($)..." />
            ) : (
              <>
                <span className={styles.sectionName}>Investment ($)</span>
                <span className={styles.big}>
                  {nrsData.data?.total_investments?.main_value ? "$" : ""}
                  {`${nrsData.data?.total_investments?.main_value}${nrsData.data?.total_investments?.main_value ? "M" : ""}` || "NA"}
                </span>
              </>
            )
          }
        </div>
        <div className={classNames(genericStyles.columnCard, "w-50 ml-1 align-items-center mb-0")}>
          {
            nrsData.fetching ? (
              <LoadingComponent customText="Getting Savings ($)..." />
            ) : (
              <>
                <span className={styles.sectionName}>Savings ($)</span>
                <span className={styles.big}>
                  {nrsData.data?.total_savings?.main_value ? "$" : ""}
                  {`${nrsData.data?.total_savings?.main_value}${nrsData.data?.total_savings?.main_value ? "M" : ""}` || "NA"}
                </span>
              </>
            )
          }
        </div>
      </div>
    </div>
  );
};

export default React.memo(FordProjectNumbers);
